module.exports = {
  canvas: require('./canvas'),
  svg: require('./svg')
};